module.exports = __webpack_public_path__ + "img/school_xazz.1ecb3fad.png";